import css from './EditListingDetailsPanel.module.css';
import React from 'react';
import { Heading } from '@chakra-ui/react';
import { LISTING_TYPES } from '../../listingTypeConfig';

const descriptionContent = {
  [LISTING_TYPES.VENUE_PAGE]: {
    title: 'What to include in your venue description',
    points: [
      'What should a newcomer to your Club expect when joining?',
      'What standout features, equipment or expertise do you offer?',
      'How would you describe the atmosphere?',
      'What outcomes can members expect over time?',
    ],
  },
  [LISTING_TYPES.CLASS]: {
    title: 'What to include in your class description',
    points: [
      'What should a newcomer to your class expect when joining?',
      'What standout features, equipment or expertise do you offer?',
      'How would you describe the atmosphere?',
      'What outcomes can students expect over time?',
    ],
  },
  [LISTING_TYPES.PERSONAL_TRAINER]: {
    title: 'What to include in your PT description',
    points: [
      'What should a new client expect when signing up?',
      'What standout features, equipment or expertise do you offer?',
      'How do you motivate or encourage your clients to stay consistent?',
      'What outcomes can members expect over time?',
    ],
  },
};

export const ListingGuide = ({ listingType }) => {
  const content = descriptionContent[listingType];

  return (
    <div className={css.listingGuideContainer}>
      <Heading as={'h2'} size="lg">
        <span className={css.footfallFont}>FootFall</span> listing guide
      </Heading>

      <div className={css.listingGuide}>
        <div>
          <Heading as={'h3'} size="md">
            Effective language tips
          </Heading>
          <ul>
            <li>
              <strong>Do </strong>refer to your service or team in the first person (i.e. "I" or
              "we").
            </li>
            <li>
              <strong>Do </strong>write in full sentences with proper punctuation and spelling.
            </li>
            <li>
              <strong>Don’t </strong>promote weight loss, body shaping, or dieting.
            </li>
            <li>
              <strong>Don’t </strong>negatively mention other gyms, studios, or competitors.
            </li>
          </ul>
        </div>
        {content && (
          <div>
            <Heading as={'h3'} size="md">
              {content.title}
            </Heading>
            <ul>
              {content.points.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export const customFieldsHelperTexts = {
  title: 'This will be the first thing users see.',
  categoryLevel2: {
    [LISTING_TYPES.CLASS]:
      'InHouse is for classes hosted within your main venue. ' +
      'Whereas FlexSpace is for classes hosted at various locations. Each class listing will only have one fixed location.',
  },
  isBookableOnFootFall:
    'Booking via FootFall is coming soon! ' +
    'Please enable this option if you’d be open to accepting bookings through FootFall in the future.',
  howToPrepare:
    'Let clients know if they need to bring any equipment, wear specific clothing, or prepare anything before getting started.',
  vibesTag:
    'Choose up to 2 words that best describe the feel of your gym. This helps more people discover your listing.',
  dropInAvailable:
    'Select this if you offer any kind of one-time access that anyone can use without a membership.',
  pricingDetails:
    '(Optional) Add information on any membership packages or promotional offerings you may have.',
  accessibilityDetails: `(Optional) Specify if there's any specific accessibility details for this listing.`,
  description: {
    [LISTING_TYPES.CLASS]:
      'Your class listing is your chance to let people know what to expect. Be clear and specific, and use the questions above to help you write a great description.',
    [LISTING_TYPES.PERSONAL_TRAINER]:
      'Your personal trainer page is your chance to let people know what to expect. Be clear and specific, and use the questions above to help you write a great description.',
    [LISTING_TYPES.VENUE_PAGE]: `Your venue's listing page is your chance to let people know what to expect. Be clear and specific, and use the questions above to help you write a great description.`,
  },
  price: {
    [LISTING_TYPES.CLASS]:
      'List the cost of a single class. If you offer bulk packages, you can show the per-class rate based on the cheapest option available to give customers a better idea of value.',
    [LISTING_TYPES.PERSONAL_TRAINER]:
      'List the cost of a single session. If you offer bulk packages, you can show the per-session rate based on the cheapest option available to give customers a better idea of value.',
    [LISTING_TYPES.VENUE_PAGE]: `Enter your lowest standard monthly rate (excluding any discounts or off-peak).`,
  },
};
